var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import * as Elements from '../../components/Legend/Legend.styles';
var Item = styled(Elements.Item)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  pointer-events: none;\n"], ["\n  border: 0;\n  pointer-events: none;\n"])));
export var Label = function (_a) {
    var active = _a.active, color = _a.color, label = _a.label, subLabel = _a.subLabel, status = _a.status;
    var Icon = React.useMemo(function () { return React.createElement(Elements.Icon, { iconColor: color }); }, [label]);
    return (React.createElement(Item, { status: status, className: "LegendChip", active: active, wafer: subLabel === undefined, icon: Icon, appearance: "plain" },
        React.createElement(Elements.Label, null, label),
        subLabel !== undefined && (React.createElement(Elements.SubLabel, null, subLabel))));
};
var templateObject_1;
//# sourceMappingURL=Label.js.map